var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2278 18.5193C18.5132 18.6691 18.5132 19.0778 18.2278 19.2277L10.7343 23.1607C10.468 23.3005 10.1484 23.1073 10.1484 22.8065L10.1484 14.9405C10.1484 14.6397 10.468 14.4465 10.7343 14.5863L18.2278 18.5193Z",
    stroke: "#FFF057",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2278 18.5193C28.5132 18.6691 28.5132 19.0778 28.2278 19.2277L20.7343 23.1607C20.468 23.3005 20.1484 23.1073 20.1484 22.8065L20.1484 14.9405C20.1484 14.6397 20.468 14.4465 20.7343 14.5863L28.2278 18.5193Z",
    stroke: "#FFF057",
    strokeWidth: 1.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 1.02188,
    width: 36.2194,
    height: 36.2194,
    rx: 18.1097,
    stroke: "#FFF057",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextActive);
export default __webpack_public_path__ + "static/media/next-active.e17f1996c9c96bbacb8739686bbcf75c.svg";
export { ForwardRef as ReactComponent };